const textStyleWeightOptions = {
  'TEXT-400': 'text-400',
  'TEXT-500': 'text-500',
  'TEXT-600': 'text-600',
  'TEXT-700': 'text-700'
}

const textStyleWeightStyleOptions = {
  [textStyleWeightOptions['TEXT-400']]: {
    fontFamily: '"Raleway-Regular", "sans-serif"'
  },
  [textStyleWeightOptions['TEXT-500']]: {  // default
    fontFamily: '"Raleway-Medium", "sans-serif"'
  },
  [textStyleWeightOptions['TEXT-600']]: {
    fontFamily: '"Raleway-SemiBold", "sans-serif"'
  },
  [textStyleWeightOptions['TEXT-700']]: {
    fontFamily: '"Raleway-Bold", "sans-serif"'
  }
}

const textStyleSizeOptions = {
  'TEXT-XS': 'text-xs', 
  'TEXT-S': 'text-s',
  'TEXT-R': 'text-r', // default
  'TEXT-L': 'text-l',
  'TEXT-XL': 'text-xl',
  'TEXT-XXL': 'text-xxl',
  'TEXT-XXXL': 'text-xxxl'
}

const textStyleSizeStyleOptions = {
  [textStyleSizeOptions['TEXT-XS']]: {
    fontSize: '0.625rem',
    lineHeight: '0.8125rem',
    letterSpacing: '0.013rem'
  },
  [textStyleSizeOptions['TEXT-S']]: {
    fontSize: '0.75rem',
    lineHeight: '0.975rem',
    letterSpacing: '0.013rem'
  },
  [textStyleSizeOptions['TEXT-R']]: {
    fontSize: '0.875rem',
    lineHeight: '1.1475rem',
    letterSpacing: '0.013rem'
  }, // default
  [textStyleSizeOptions['TEXT-L']]: {
    fontSize: '1rem',
    lineHeight: '1.3rem',
    letterSpacing: '0.013rem'
  },
  [textStyleSizeOptions['TEXT-XL']]: {
    fontSize: '1.125rem',
    lineHeight: '1.4625rem',
    letterSpacing: '0.013rem'
  },
  [textStyleSizeOptions['TEXT-XXL']]: {
    fontSize: '1.5rem',
    lineHeight: '1.95rem',
    letterSpacing: '0.013rem'
  },
  [textStyleSizeOptions['TEXT-XXXL']]: {
    fontSize: '2rem',
    lineHeight: '2.6rem',
    letterSpacing: '0.013rem'
  }
}

export {
  textStyleSizeOptions,
  textStyleWeightOptions,
  textStyleSizeStyleOptions,
  textStyleWeightStyleOptions
}
